export type * from "./types";
export * from "./config";
export * from "./lib";

export {default as KillfeedTable} from "./components/killfeed-table";
export {default as LeaderboardTable} from "./components/leaderboard-table";
export {default as Settings} from "./components/settings";
export {default as StatsTable} from "./components/stats-table";
export {default as Navigation} from "./components/navigation";
export {default as WeaponsTable} from "./components/weapons-table";

import type {Killfeed, Wipe, Leaderboard, WeaponStats} from "./types";
import rawKillfeed from "./generated/killfeed.json";
import rawWipes from "@/../resources/dusk-wipes.json";
import rawLeaderboard from "./generated/leaderboard.json";
import rawWeapons from "./generated/weapons.json";
const killfeed = rawKillfeed as Killfeed;
const wipes = rawWipes as Wipe[];
const leaderboard = rawLeaderboard as Leaderboard;
const weapons = rawWeapons as WeaponStats[][];
export {killfeed, wipes, leaderboard, weapons};
